export default {
  serverURI: process.env.SERVER_URI || 'http://localhost:7000',
  streamingURI: process.env.STREAMING_URI || 'http://localhost:8200',
  domain: process.env.DOMAIN || 'http://localhost:8080',
  webSocketServer: process.env.WEB_SOCKET_SERVER || 'ws://localhost:7000/websocket',
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js